<vs-dialog [config]="dialogConfig ?? { dialogContainerClass: 'max-w-[525px]' }" (closed)="cancelationRule = null">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      hideCloseButton: false,
  
      icon: 'edit-03',
      iconTheme: 'primary',

      showDivider: true,

      title: 'Cancellation Rule',
      subtitle: 'Modify the cancellation rule for this policy.'
    }"
  ></vs-dialog-header>

  <form [formGroup]="form" class="mt-3">
    <div class="flex gap-2">
      <vs-form-field
        [theme]="
    (form.controls.country.touched && form.controls.country.hasError('required')) ||
    form.controls.country.hasError('pattern')
      ? 'danger'
      : 'primary'
  "
        [config]="{ label: 'Country' }"
      >
        <vs-select
          [disabled]="!!cancelationRule"
          [config]="{ placeholder: 'Select country' }"
          vsInput
          type="text"
          formControlName="country"
        >
          <li vs-select-option *ngFor="let country of COUNTRIES" [value]="country.abbreviation">{{ country.name }}</li>
        </vs-select>

        <span
          class="text-danger"
          slot="hint"
          *ngIf="form.controls.country.touched && form.controls.country.hasError('required')"
        >
          Country is required
        </span>
        <span
          class="text-danger"
          slot="hint"
          *ngIf="form.controls.country.touched && form.controls.country.hasError('pattern')"
        >
          Valid country values are 'US', 'CA'
        </span>
      </vs-form-field>

      <vs-form-field
        [theme]="
    (form.controls.country.touched && form.controls.country.hasError('required')) ||
    form.controls.country.hasError('pattern')
      ? 'danger'
      : 'primary'
  "
        [config]="{ label: 'State' }"
      >
        <div *vsLet="states$ | async"></div>
        <vs-select
          [disabled]="!!cancelationRule"
          [config]="{ placeholder: 'Select state' }"
          vsInput
          class="rounded-md text-md text-gray-900"
          type="text"
          formControlName="state"
        >
          <li
            vs-select-option
            class="flex items-center gap-2"
            *ngFor="let state of stateValues$ | async"
            [value]="state.abbreviation"
            [disabled]="takenStates?.includes(state.abbreviation)"
          >
            {{ state.name }}
          </li>
        </vs-select>
        <span
          class="text-danger"
          slot="hint"
          *ngIf="form.controls.state.touched && form.controls.state.hasError('required')"
        >
          State is required
        </span>
      </vs-form-field>
    </div>

    <vs-form-field theme="primary" [config]="{ label: 'Cancellation Fee' }" class="mt-4">
      <input
        vsInput
        currencyMask
        id="basic-text-input"
        type="text"
        formControlName="adminFee"
        [options]="currencyMaskConfig"
      />
    </vs-form-field>

    <vs-form-field theme="primary" [config]="{ label: 'Deduct Claims Paid (from refund amount)' }" class="mt-4">
      <input vsInput id="basic-text-input" type="checkbox" formControlName="deductClaims" appearance="toggle" />
    </vs-form-field>

    <label class="text-gray-700 font-medium" style="font-size: 0.875rem; line-height: 2.25rem">Rule Text</label>
    <vs-rich-text-editor *ngIf="cancelationRule; else otherRuleText" formControlName="ruleText"></vs-rich-text-editor>
    <ng-template #otherRuleText>
      <vs-rich-text-editor formControlName="ruleText"></vs-rich-text-editor>
    </ng-template>
  </form>

  <div class="flex footer mt-5 gap-2 justify-end">
    <button vs-button size="md" appearance="outline" [disabled]="saving" (click)="cancel()">Cancel</button>
    <button vs-button size="md" theme="primary" [disabled]="saving || form.invalid || !form.dirty" (click)="submit()">
      {{ cancelationRule ? 'Update' : 'Create' }}
    </button>
  </div>
</vs-dialog>
